import type { TypeTableColumn } from '@thefarmersfront/kitchen';

import { StockReleaseRequestQuantityInputCell } from '~/components/stock/StockCellRenderer';

import { formatNumber } from '~/utils';

import type { TypeStockReleaseGoods } from '~/types/stock.types';

const formatQuantity = (value: unknown): string => formatNumber(typeof value === 'number' ? value : 0);

const RIGHT_ALIGN = { cellStyle: { textAlign: 'right' } } as const;

/**
 * [재고관리 > 반출 요청 관리] 반출 요청 등록 > 반출 요청 상품 테이블
 *
 * 수량을 입력할 때마다 목록 데이터가 새로 만들어져, 행 id(skuCode)로 행과 선택을 유지한다.
 */
const getStockReleaseRegisterGoodsColumnDefs = () => {
  const getRowId = (row: TypeStockReleaseGoods) => String(row.skuCode);

  const columnDefs: TypeTableColumn<TypeStockReleaseGoods>[] = [
    {
      id: 'selection',
      header: '',
      cell: () => null,
      size: 44,
      meta: { selection: true },
    },
    {
      accessorKey: 'skuName',
      header: '상품명',
      size: 240,
    },
    {
      accessorKey: 'temperatureTypeCodeObject.name',
      header: '보관 유형',
      size: 76,
    },
    {
      accessorKey: 'availableQuantity',
      header: '가용 재고',
      size: 76,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'availableRequestQuantity',
      header: '반출 요청 수량 (가용)',
      size: 155,
      cell: ({ row }) => (
        <StockReleaseRequestQuantityInputCell
          data={row.original}
          rowIndex={row.index}
          field="availableRequestQuantity"
        />
      ),
    },
    {
      accessorKey: 'defectiveQuantity',
      header: '불용 재고',
      size: 90,
      cell: ({ getValue }) => formatQuantity(getValue()),
      meta: RIGHT_ALIGN,
    },
    {
      accessorKey: 'defectiveRequestQuantity',
      header: '반출 요청 수량 (불용)',
      size: 155,
      cell: ({ row }) => (
        <StockReleaseRequestQuantityInputCell
          data={row.original}
          rowIndex={row.index}
          field="defectiveRequestQuantity"
        />
      ),
    },
    {
      accessorKey: 'holdingQuantity',
      header: '보류 재고',
      meta: {
        cellStyle: { textAlign: 'right' },
        headerTooltip: { description: '보류 재고는 반출 요청할 수 없습니다.', maxWidth: '198px' },
      },
      size: 96,
      cell: ({ getValue }) => formatQuantity(getValue()),
    },
    {
      accessorKey: 'skuCode',
      header: 'SKU코드',
      size: 140,
    },
    {
      accessorKey: 'barcode',
      header: '상품 바코드',
      size: 140,
    },
  ];

  return { getRowId, columnDefs };
};

export default getStockReleaseRegisterGoodsColumnDefs;
